import { parseCSSVariableDuration } from './parseCSSVariableDuration';

export const getCardRemovalAnimationDuration = (): number => {
  const transitionTime = parseCSSVariableDuration('--transition-time', 300);
  const cardRemovalDelay = parseCSSVariableDuration(
    '--card-removal-delay',
    200,
  );

  return transitionTime + cardRemovalDelay + transitionTime;
};
